"use client";

import useGetVideo from "./hooks/useGetVideo";

const Videos = () => {
  const link = useGetVideo();

  return (
    // <section className="container mx-auto my-16">
    //   <iframe
    //     width="560"
    //     height="315"
    //     className="w-full h-44 md:h-[509px] rounded-[16px] object-contain"
    //     src={link}
    //     title="YouTube video player"
    //     frameBorder="0"
    //     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    //     referrerPolicy="strict-origin-when-cross-origin"
    //     allowFullScreen
    //   />
    // </section>
    <section className="container mx-auto my-16">
      {link ? (
        <video
          className="w-full h-44 md:h-[509px] rounded-[16px] object-cover"
          controls
          autoPlay
        >
          <source
            src={process.env.NEXT_PUBLIC_SPACES_URL + link}
            type="video/mp4"
          />
        </video>
      ) : (
        ""
      )}
    </section>
  );
};

export default Videos;
